import styled from "styled-components";

import { TriggerButton } from "commons";

export const DownloadButton = styled(TriggerButton)`
    height: 30px;
    width: 128px;
    max-width: 128px;
    background-color: white;
    color: ${props => props.theme.primary};

    &:focus {
        text-decoration: underline;
    }

    &:hover {
        text-decoration: underline;
    }
`;
